module.exports = __webpack_public_path__ + "img/Trazado 8338.98bd407f.svg";